(async function handleIpRedirect() {
    const LOCAL_STORAGE_KEY = 'boa-geolocation';
    const ACTIONS = {
        REDIRECT: 'redirect',
        STAY: 'stay',
    };
	// See if this device has already been checked
    const previousGeolocationCheck = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (previousGeolocationCheck === ACTIONS.REDIRECT) {
        window.location.href = 'https://www.laline.com.tw';
        return;
    }
    if (previousGeolocationCheck === ACTIONS.STAY) {
        document.body.style.visibility = 'visible';
        return;
    }

	// This is the first time this device is being checked
    const TAIWAN_COUNTRY_CODE = 'TW';

    const ipResponse = await fetch('https://api.ipify.org?format=json');
    const { ip } = await ipResponse.json();
	

    const geolocationRequest = await fetch(`https://ipapi.co/${ip}/json/`);
    const { country } = await geolocationRequest.json();

    if (country.toUpperCase() === TAIWAN_COUNTRY_CODE && !Shopify.designMode) {
        localStorage.setItem(LOCAL_STORAGE_KEY, ACTIONS.REDIRECT);
        window.location.href = 'https://www.laline.com.tw';
    } else {
        localStorage.setItem(LOCAL_STORAGE_KEY, ACTIONS.STAY);
        document.body.style.visibility = 'visible';
    }
})();
